<template>

     <template v-if="currentSchoolyear && adminSchoolyear">

        <el-card shadow="hover">
            <el-row align="middle">
                <el-col :span="12">
                    <div class="text-left">
                        <h3>{{ $t('activities') }}</h3>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="text-right">
                        <el-button size="default" @click="addItem()">
                            {{ $t('add') }}
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-table :data="pagedTableData" :empty-text="$t('noData')" style="width: 100%" border stripe v-loading="isLoading">

                <el-table-column type="index" :index="indexMethod"> </el-table-column>
                <el-table-column sortable :label="$t('name')" prop="name"> </el-table-column>
                <el-table-column sortable :label="$t('type')" prop="type">
                    <template #default="scope">
                        {{ getActivityTypeLabel(scope.row.type) }}
                    </template>
                </el-table-column>

                <el-table-column align="right">

                    <template #header>
                        <el-input v-model="search" size="small" :placeholder="$t('search')" />
                    </template>

                    <template #default="scope">
                        <el-button size="small" @click="editItem(scope.$index, scope.row)">
                            {{ $t('edit') }}
                        </el-button>
                        <el-button size="small" type="danger" @click="deleteItem(scope.$index, scope.row)">
                            {{ $t('delete') }}
                        </el-button>
                    </template>

                </el-table-column>

            </el-table>

            <div style="text-align: center; margin-top: 20px">

                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="setPage"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>

            </div>
        </el-card>

        <el-dialog :title="$t('addActivity')" v-model="addDialog" width="50%">

            <el-form
                label-width="200px"
                label-position="left"
                hide-required-asterisk
                :model="addActivity"
                :ref="addActivityForm"
                :rules="rules">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="addActivity.name"/>
                </el-form-item>

                <el-form-item prop="type" :label="$t('activityType')">
                    <el-select
                        filterable
                        v-model="addActivity.type"
                        :placeholder="$t('select')"
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 100%">
                        <el-option
                            v-for="item in activityTypes"
                            :key="item.id"
                            :value="item.id"
                            :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(addActivityForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(addActivityForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

        <el-dialog :title="$t('editActivity')" v-model="editDialog" width="50%">

            <el-form
                label-width="200px"
                label-position="left"
                hide-required-asterisk
                :model="editActivity"
                :ref="editActivityForm"
                :rules="rules">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="editActivity.name"/>
                </el-form-item>

                <el-form-item prop="type" :label="$t('activityType')">
                    <el-select
                        filterable
                        v-model="editActivity.type"
                        :placeholder="$t('select')"
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 100%">
                        <el-option
                            v-for="item in activityTypes"
                            :key="item.id"
                            :value="item.id"
                            :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(editActivityForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(editActivityForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

     </template>

     <el-alert :title="$t('noCurrentSchoolyearWarning')" type="warning" v-else/>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import fr from 'element-plus/lib/locale/lang/fr'

import { ActivityTypes } from '@/utils/enums'

import accessManager from '@/mixins/access-manager'

export default {
    name: 'Activities',
    mixins: [accessManager],
    data() {
      return {
        activityTypes: [],
        primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
        editActivity: {
            name: '',
            type: ''
        },
        addActivity: {
            name: '',
            type: ''
        },
        rules: {
            name: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            type: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ]
        },
        editActivityForm: 'editActivityForm',
        addActivityForm: 'addActivityForm',
        currentEditItem: null,
        editDialog: false,
        isLoading: false,
        addDialog: false,
        tableData: [],
        pageSize: 6,
        locale: fr,
        search: '',
        total: 0,
        page: 1
      }
    },
    created() {

      this.fetchActivities()

      var self = this

      this.$_.forIn(ActivityTypes, function(value, key) {

          self.activityTypes.push(value)

      })

    },
    computed:{
      ...mapState({
        userData: state => state.session.userData
      }),
      ...mapGetters({
        getSettingValue: 'settings/getSettingValue'
      }),
      pagedTableData() {

        this.total = this.searching.length

        return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)

      },
      searching() {

        if (!this.search) {
            this.total = this.tableData.length
            return this.tableData
        }

        this.page = 1

        return this.tableData.filter(data => data.name.toLowerCase().includes(this.name.toLowerCase()))

      }
    },
    methods: {
      ...mapActions({
         fetchActivitiesDB: 'activities/fetchActivitiesDB',
      }),
      setPage (val) {

         this.page = val

      },
      indexMethod(index) {

         return index + ((this.page - 1) * this.pageSize) + 1

      },
      getActivityTypeLabel(id){

          let activityType = this.activityTypes.find(f => f.id == id)

          return activityType ? activityType.label : ''

      },
      async fetchActivities(){

        if (!this.adminSchoolyear) return

        this.isLoading = true

        let resp = await this.fetchActivitiesDB({
            action: 'getActivities',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp.success){

            if (resp.data) this.tableData = resp.data

        }else{

            this.$message.error(this.$t('anErrorOccured'))

        }

        this.isLoading = false

      },
      addItem(){

           if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
           }

           this.addDialog = true

      },
      async editItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.currentEditItem = item

            this.editActivity.name = item.name
            this.editActivity.type = parseInt(item.type)

            this.editDialog = true

      },
      deleteItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.$confirm(this.$t('deleteActivityQuestion'), this.$t('delete'), {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
            })
            .then(async () => {

                let task = await this.fetchActivitiesDB({
                    action: 'deleteActivity',
                    params: {
                        id: item.id
                    }
                })

                if (task.success){

                    this.$message.success(this.$t('success'))
                    this.fetchActivities()

                }else{

                    this.$message.error(this.$t('anErrorOccured'))

                }

            })
            .catch(() => {

            })

      },
      submitForm(ref){

            this.$refs[ref].validate(async (valid) => {
                if (valid) {

                    if (ref === this.addActivityForm){

                        let task = await this.fetchActivitiesDB({
                            action: 'addActivity',
                            params: {
                                name: this.addActivity.name,
                                type: this.addActivity.type,
                                schoolyear: this.adminSchoolyear
                            }
                        })

                        if (task.success) this.$message.success(this.$t('success'))
                        else this.$message.error(this.$t('anErrorOccured'))

                    }else{

                        let newData = {}

                        if (this.currentEditItem.name !== this.editActivity.name) {
                            newData['name'] = this.editActivity.name
                        }

                        if (this.currentEditItem.type !== this.editActivity.type) {
                            newData['type'] = this.editActivity.type
                        }

                        if (!this.$_.isEmpty(newData)){
                            let task = await this.fetchActivitiesDB({
                                action: 'editActivity',
                                params: {
                                    id: this.currentEditItem.id,
                                    data: newData
                                }
                            })

                            if (task.success) this.$message.success(this.$t('success'))
                            else this.$message.error(this.$t('anErrorOccured'))
                        }

                    }

                    this.cancelForm(ref)
                    this.fetchActivities()

                } else {
                    return false
                }
            })

      },
      cancelForm(ref){

            this.$refs[ref].resetFields()

            if (ref === this.addActivityForm) this.addDialog = false
            else this.editDialog = false

      }
    },
}
</script>